import React, { memo, ReactElement, useCallback } from 'react';
import { IOption } from 'reactApp/ui/Header/Search/Search.data';
import { CancelIcon } from 'reactApp/ui/VKUIIcons';

import styles from './FilterLabel.css';

type Props = IOption & { removeFilter: () => void };

export const FilterLabel = memo(({ id, icon, text, removeFilter }: Props): ReactElement | null => {

    const onClick = useCallback((event) => {
        event.stopPropagation();
        removeFilter();
    }, [removeFilter])

    if (id === 'all') {
        return null;
    }

    return (
        <div className={styles.root}>
            <div className={styles.icon}>{icon}</div>
            <div className={styles.text}>{text}</div>
            <div className={styles.cancel} onClick={onClick}>
                <CancelIcon />
            </div>
        </div>
    );
});

FilterLabel.displayName = 'FilterLabel';
